import { styled, Tabs } from "@mui/material";

export const StyledTabBar = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
  })),
  Tabs: styled(Tabs)(({ theme }) => ({
    minHeight: 36,
    "& .MuiTabs-indicator": {
      height: 3,
    },
    "& .MuiTab-root": {
      minHeight: 36,
      padding: "6px 16px",
      fontSize: "0.875rem",
      fontFamily: "Roboto, sans-serif",
      fontWeight: 500,
      textTransform: "none",
    },
  })),
};
